import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=46434ff3"
import script from "./Department.vue?vue&type=script&lang=ts"
export * from "./Department.vue?vue&type=script&lang=ts"
import style0 from "../../scss/grid.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Department.vue?vue&type=style&index=1&id=46434ff3&prod&lang=css"
import style2 from "../../scss/base.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports